/**
 * Created by lihanying on 2017/7/6.
 */

export const GETCLUBTABLELIST = 'GETCLUBTABLELIST'
export const GETCLUBTABLEDETAIL = 'GETCLUBTABLEDETAIL'
export const GETCLUBSETTLEMENT = 'GETCLUBSETTLEMENT'
export const GETCLUBBILLRECORD = 'GETCLUBBILLRECORD'


// WEBPACK FOOTER //
// ./src/containers/ClubTableStatus/constants.js